import { Box, Heading, Stack, Text } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PROTECTED_PATHS } from '../../app/constants';
import Container from '../../components/Container';
import Footer from '../../components/footer';
import FullPageLoader from '../../components/FullPageLoader';
import Header from '../../components/Header';
import { dynamicPathhandler } from '../../components/utils/dynamicPathHandler';
import { useAuth } from '../../context/authContext';
import { getPolls } from './service';

const { VOTE } = PROTECTED_PATHS;

const Polls = () => {
  const { userInfo } = useAuth();
  const { userId } = userInfo;
  const [loading, setLoading] = useState(false);
  const parent = dynamicPathhandler(VOTE);
  const navigate = useNavigate();
  const [polls, setPolls] = useState([]);

  useEffect(() => {
    getPolls(setLoading, userId, setPolls);
  }, [userId]);

  return loading ? (
    <FullPageLoader />
  ) : (
    <Stack mb='24'>
      <Box shadow='sm'>
        <Container>
          <Header menu />
        </Container>
      </Box>
      <Container>
        <Heading>Polls</Heading>
        <Text py='4'>Click on a poll to participate and say your opinion</Text>
      </Container>

      <Container>
        {polls?.map((poll) => (
          <Stack
            my='8'
            key={poll._id}
            p='2'
            borderRadius='4px'
            spacing='2'
            bg='gray.100'
            shadow='sm'
            onClick={() => navigate(`${parent}/${poll?._id}`)}
          >
            <Text fontWeight='600' fontSize='1rem'>
              {poll?.title}
            </Text>
            <Text textAlign='right'>Start Time {dayjs(polls?.startDate).format('DD MMM YYYY HH:mm')}</Text>
          </Stack>
        ))}
      </Container>

      <Footer />
    </Stack>
  );
};

export default Polls;
